import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { REGISTER_USER_URL, USERS_URL } from "../../settings/APISetting";
import { sortByProp } from "../../settings/themeSettings";
import axiosInstance from "../../config/axiosConfig";

export const fetchUsers = createAsyncThunk('fetch-users', async () => {
    const response = await axiosInstance.get(USERS_URL);
    return response.data;
});

export const createUser = (user, err, cb) => {
    axiosInstance.post(REGISTER_USER_URL, user)
        .then((response) => {
            cb(response.data);
        })
        .catch(err);
}

export const updateUser = (user, err, cb) => {
    axiosInstance.put(REGISTER_USER_URL, user)
        .then((response) => {
            cb(response.data);
        })
        .catch(err);
}

export const deleteUser = (id, err, cb) => {
    axiosInstance.delete(`${USERS_URL}/${id}`)
        .then((response) => {
            cb(response.data);
        })
        .catch(err);
}


const userSlice = createSlice({

    name: 'users',
    initialState: { users: [], fetchUsersStatus: '' },

    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchUsers.fulfilled, (state, action) => {

            if (Array.isArray(action.payload)) {
                state.users = [...action.payload].sort((a, b) => sortByProp(a, b, 'nomComplet'));
            } else {
                console.error('fetchUsers payload is not an array:', action.payload);
                state.users = [];
            }
            state.fetchUsersStatus = 'success';
        }).addCase(fetchUsers.pending, (state, action) => {
            state.fetchUsersStatus = 'loading';

        }).addCase(fetchUsers.rejected, (state, action) => {

            state.fetchUsersStatus = 'error';

        });
    }


});
export default userSlice;